function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Group");

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "38.6274823%",
  y1: "-5.26315789e-06%",
  x2: "88.6786391%",
  y2: "56.1621053%",
  id: "linearGradient-1"
}, React.createElement("stop", {
  stopColor: "#ADCEFF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#E1EDFF",
  offset: "52.6042%"
}), React.createElement("stop", {
  stopColor: "#FAFCFF",
  offset: "100%"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Final-Design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Aura-Integration-Card-V1.1---High-fidelity",
  transform: "translate(-126, -293)"
}, React.createElement("g", {
  id: "Group-6",
  transform: "translate(96, 269)"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(30, 24)"
}, React.createElement("rect", {
  id: "Rectangle",
  fill: "url(#linearGradient-1)",
  fillRule: "nonzero",
  x: 0,
  y: 0,
  width: 51,
  height: 54.3874346,
  rx: 9
}), React.createElement("rect", {
  id: "Rectangle",
  fill: "url(#linearGradient-1)",
  fillRule: "nonzero",
  x: 0,
  y: 0,
  width: 51,
  height: 54.3874346,
  rx: 9
}), React.createElement("path", {
  d: "M20.2766605,13.8232821 L30.7297816,13.8232821 L30.7297816,16.4972833 L20.2766605,16.4972833 L20.2766605,13.8232821 Z M17.5472211,40.5638662 L24.2565395,21.8455718 L26.7386289,21.8455718 L33.4480816,40.5638662 L30.7625289,40.5638662 L25.4975842,25.8756807 L20.2327737,40.5638662 L17.5472211,40.5638662 Z",
  id: "Shape",
  fill: "#191C1F"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "51px",
    height: "55px",
    viewBox: "0 0 51 55",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/aura-logo.0fee1c2c.svg";
export { SvgComponent as ReactComponent };